<template>
  <div data-component="app-launcher-content">
    <app-launcher-warning-container v-if="showWarning" />
    <app-launcher-update-container v-else-if="showUpdateProgress" />

    <template v-else-if="showLauncherSettings">
      <app-launcher-links-container />
      <apps-integration-container />
      <app-launcher-settings-container />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppLauncherLinksContainer from '../containers/AppLauncherLinksContainer.vue';
import AppLauncherSettingsContainer from '../containers/AppLauncherSettingsContainer.vue';
import AppLauncherUpdateContainer from '../containers/AppLauncherUpdateContainer.vue';
import AppLauncherWarningContainer from '../containers/AppLauncherWarningContainer.vue';
import { AppsIntegrationContainer } from '../modules/apps-integration';
import { APP_STATES, APP_STATE_PROP } from '../constants';

export default defineComponent({
  name: 'AppLauncherContent',
  components: {
    AppLauncherLinksContainer,
    AppLauncherSettingsContainer,
    AppsIntegrationContainer,
    AppLauncherUpdateContainer,
    AppLauncherWarningContainer,
  },
  props: {
    appState: APP_STATE_PROP,
  },
  computed: {
    showWarning() {
      return [
        APP_STATES.NO_AGENT_ACCESS,
        APP_STATES.NO_APP_AVAILABLE,
        APP_STATES.NO_APP_VERSION,
        APP_STATES.NO_APP_VERSION_SUPPORT,
        APP_STATES.DATA_UPDATE_ERROR_ADMIN,
        APP_STATES.DATA_UPDATE_ERROR_AGENT,
        APP_STATES.NEEDS_DATA_UPDATE,
        APP_STATES.APP_ERROR,
      ].includes(this.appState);
    },
    showUpdateProgress() {
      return this.appState === APP_STATES.APP_IS_UPDATING;
    },
    showLauncherSettings() {
      return this.appState === APP_STATES.APP_SETTINGS;
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='app-launcher-content'] {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--s-5);
  overflow: auto;

  @include md {
    width: 40rem;
  }
}
</style>
